import { call, put } from 'redux-saga/effects';

import { fetchInvestorRelations } from 'services';

import { GET_INVESTOR_RELATIONS_FINISHED } from './investorActions';

export function* fetchInvestorRelationsSaga({ payload }) {
  try {
    const response = yield call(fetchInvestorRelations, payload);
    yield put({ type: GET_INVESTOR_RELATIONS_FINISHED, payload: response });
  } catch (response) {
    yield put({ type: GET_INVESTOR_RELATIONS_FINISHED, payload: response });
  }
}
